import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, Save, Send } from 'lucide-react';

interface Props {
  currentStep: number;
  totalSteps: number;
  saving: boolean;
  onBack: () => void;
  onSaveDraft: () => void;
  onNext: () => void;
  isLastStep?: boolean;
}

export default function StepNavigation({ currentStep, totalSteps, saving, onBack, onSaveDraft, onNext, isLastStep }: Props) {
  return (
    <div className="flex justify-between items-center mt-6 pt-5 border-t border-border">
      <Button variant="outline" onClick={onBack} disabled={currentStep === 1 || saving}>
        <ChevronLeft className="w-4 h-4 mr-1" /> Back
      </Button>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onSaveDraft} disabled={saving} size="sm">
          <Save className="w-3.5 h-3.5 mr-1.5" /> Save Draft
        </Button>
        <Button onClick={onNext} disabled={saving} className="bg-primary text-primary-foreground">
          {saving ? 'Saving...' : isLastStep
            ? <><Send className="w-4 h-4 mr-1.5" /> Submit</>
            : <>Next <ChevronRight className="w-4 h-4 ml-1" /></>}
        </Button>
      </div>
    </div>
  );
}
